// extracted by mini-css-extract-plugin
module.exports = {"component":"CartMobileSummary_component__sjGQT","row":"CartMobileSummary_row__tL5aO"};